var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.951 0-.195.638v18.514l.195.187 8.929-5.08L9.95 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95 0 1.02 14.26l8.93 5.08V0ZM9.952 20.967l-.11.129v6.595l.11.309 8.934-12.11-8.934 5.077Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95 28v-7.033L1.02 15.89 9.95 28ZM9.955 19.34l8.929-5.08-8.929-3.907v8.986ZM1.02 14.26l8.93 5.08v-8.987l-8.93 3.906Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h20v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherium);
export default __webpack_public_path__ + "static/media/etherium.ded8021471c5b8783eeb214d3e1f9267.svg";
export { ForwardRef as ReactComponent };